<template>
  <div
    v-if="productShippingList"
    class="productShippingMethods"
    :class="[isZeborne ? 'zeborne' : 'mcp', {'not-retailable': !isRetailable}]">
    <div
      class="productShippingMethods-type ProductShipping-cardsRow DeliveryInstall CardsChoice"
      v-for="(productShipping, index) in productShippingList"
      :key="productShipping.id"
      :class="[{'active': defaultSelectedShippingMethod === index}, `${index}`]"
    >
      <div class="productShippingMethods-inner">
        <div class="productShippingMethods-innerLeft">
          <div class="productShippingMethods-inputContainer">
            
            <!----------------------------------------
                        Radio Button
            ------------------------------------------->
            <div class="productShippingMethods-input">
              <input
                type="radio"
                name="productShipping"
                class="formatBig"
                required
                :id="productShipping.id"
                :product-shipping-name="index"
                :is-tax-reducible="productShipping.is_tax_reducible ? productShipping.is_tax_reducible : 'false'"
                :ref="index"
                :value="index"
                :data-price="
                  productShipping.is_tax_reducible
                    ? productShipping.prices[currentTva]
                    : productShipping.prices[originalTva]
                "
                @change="eventClickSelectedShippingMethod"
                v-model="defaultSelectedShippingMethod"
                v-el:=index
              />
              
              <!----------------------------------------
                        Label for Input
              ------------------------------------------->
              <label :for="productShipping.id" v-html="productShipping.name"></label>
            </div>
          </div>

          <!----------------------------------------
                Know more button dekstop
          ------------------------------------------->
          <div class="productShippingMethods-knowMore desktopOnly">
            <a
              class="more"
              data-id-target="header_installation"
              @click="scrollTo"
              type="button"
              v-if="index === 'delivery_and_installation'"
            >
              En savoir plus
            </a>
            <a
              data-id-target="delivery"
              class="more"
              type="button"
              @click="scrollTo"
              v-if="index === 'delivery_only' && hasDeliveryStrate"
            >
              En savoir plus
            </a>
          </div>
        </div>
        
        <!----------------------------------------
                Price
        ------------------------------------------->
        <div class="productShippingMethods-price">
          <ProductPriceCart
            :displayTooltip="false"
            :originalPrice="setProductShippingMethodsPrice(productShipping.is_tax_reducible, productShipping.prices.price)"
            :specialPrice="setProductShippingMethodsPrice(productShipping.is_tax_reducible, productShipping.prices.final_price)"
          ></ProductPriceCart>
        </div>
      </div>
      
      <!----------------------------------------
                Message date for
      ------------------------------------------->
      <!-- Delivery or delivery and installation -->
      <label
        class="productShippingMethods-date"
        :for="index"
        v-if="selectedDeliveryId !== productShipping.id  && !isLead"
        ><span>{{
          index === "delivery_and_installation" ||
          index === "installation" ||
          index === "intervention"
            ? "Installé"
            : "Livré"
        }}</span>&nbsp;
        <span>chez vous à partir</span>&nbsp;
        <span class="fromdate"> {{ new Date(productShipping.first_intervention_date) | formatDateIntervention() }}</span>
      </label>
      
      <!-- Lead, technical visit -->
      <label
        class="productShippingMethods-date"
        :for="index"
        v-if="isLead"
      >
        <span>Visite technique à partir</span>&nbsp;
        <span class="fromdate"> {{ new Date(productShipping.first_intervention_date) | formatDateIntervention() }}</span>
      </label>


      <!----------------------------------------
              Know more button mobile 
      ------------------------------------------->
      <div class="productShippingMethods-knowMore mobileOnly">
        <a
          data-id-target="header_installation"
          @click="scrollTo"
          type="button"
          v-if="index === 'delivery_and_installation' && hasInstallationStrate"
        >
          En savoir plus
        </a>
        <a
          data-id-target="delivery"
          class="more"
          type="button"
          @click="scrollTo"
          v-if="index === 'delivery_only' && hasDeliveryStrate"
        >
          En savoir plus
        </a>
      </div>

      <!----------------------------------------
                Calendar 
      ------------------------------------------->
      <div class="productShippingMethods-calendar" v-if="defaultSelectedShippingMethod === index">
        <!-- Message if already selected -->
        <ProductShippingMessages
          v-if="selectedDeliveryDateStart !== '' && selectedDeliveryId === productShipping.id && showModalCalendar === false"
          :selectedDeliveryDateStart="selectedDeliveryDateStart"
          :selectedDeliveryHours="selectedDeliveryHours"
          @modifySlot="reOpenModalCalendar"
        />

        <div v-else>
          <!-- MESSAGE ON SUBMIT IF DATE HAVEN'T BE SELECTED -->
          <!-- Error Message -->
          <Messages
            v-if="showSubmitMessages"
            :text="'Veuillez sélectionner une date'"
            :type="'warning'"
          ></Messages>
        </div>
      </div>

      <!----------------------------------------
                REDUCE TVA CHECKBOX  on cart page now
      ------------------------------------------->
      <!-- <div class="ProductShippingResume-reduceTva" v-if="defaultSelectedShippingMethod === index && defaultSelectedShippingMethod === 'delivery_and_installation'">
        <input
          v-model="tva"
          type="checkbox"
          id="reduceTva"
          name="reduceTva"
          :checked="tva"
          @change="toggleAppProductParticularTva"
        />
        <label for="reduceTva">
          Je bénéficie du taux de TVA réduit à {{ reducedTaxRate }}%
          <span v-if="isZeborne && storeUrlPrefix == '/be'">la première occupation du logement privé remonte à + de 10ans</span>
          <span v-else>je suis un particulier et mon logement a plus de 2 ans</span>
        </label>
      </div> -->
    </div>


    <!----------------------------------------
               Modal calendar   
    ------------------------------------------->
    <transition name="slide-fade">
      <component
        :is="modalCalendarComponent"
        v-if="showModalCalendar"
        :showModal="showModalCalendar"
        :class="'Modal-right'"
        @Modal::close="closeModalCalendar"
        :deliveryType="defaultSelectedShippingMethod"
        :deliveryId="defaultSelectedShippingMethodId"
        :onModify="onModify"
        :tvaCheckbox="tva"
        :slotsChoiceActive="(!isLead ? true : slotsChoiceActive)"
      />
    </transition>
  </div>
</template>

<script>
import ProductPriceCart from "@/includes/Product/ProductPrice/ProductPriceCart.vue";
import Messages from "@/components/Messages/Messages.vue";
import ProductShippingMessages from "@/includes/Product/ProductShippingMessages/ProductShippingMessages.vue";
import EventBus from "@/event-bus";
import { mapGetters, mapActions } from "vuex";
import "dayjs/locale/fr";
import "@/includes/Product/ProductShippingMethods/ProductShippingMethods.scss";

const ModalCalendar = () => import(/* webpackChunkName: "modal-calendar" */ '@/components/Modal/ModalCalendar.vue');
const ModalCalendarZeborne = () => import(/* webpackChunkName: "modal-calendar-zeborne" */ '@/components/Modal/zeborne/ModalCalendar.vue');

export default {
  name: "productShippingMethods",

  components: {
    ProductPriceCart,
    Messages,
    ProductShippingMessages
  },

  data () {
    return {
      defaultSelectedShippingMethod: "delivery_and_installation",
      defaultIsTaxReducible: true,
      defaultSelectedShippingMethodId: "",
      showModalCalendar: false,
      showModalInfo: false,
      modalContentInfo: "",
      onModify: false,
      showSubmitMessages: false,
      isRetailableClass: false,
      CountDownExpired: false,
      modalCalendarComponent: () => ({
        component: ModalCalendar()
      })
    };
  },

  props: {
    hasDeliveryStrate: {
      type: Boolean,
      default: false
    },
    hasInstallationStrate: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters({
      selectedDeliveryDateStart: "getDeliverySelectedDateStart",
      selectedDeliveryHours: "getDeliverySelectedHours",
      selectedDeliveryId: "getDeliverySelectedId",
      productShippingList: "getProductShippingMethods",
      productShippingInfo: "getProductShippingInfo",
      currentTva: "getProductTVAForCurrentDelivery",
      originalTva: "getProductOriginalTVA",
      isZeborne: "isZeborne",

      isTaxReducible: "isProductTaxReducible",
      isRetailable: "getProductIsRetailable",

      currentSelectedDelivery: "getPreprendCartCurrentSelectedDelivery",
      isRenting: "getPreprendCartIsRenting",

      isLead: "isLead",
      slotsChoiceActive: "getProductSlotsChoiceActive",
      reducedTaxRate: "getProductReducedTaxRate",
      tvaProfils: "getTvaProfils",
      storeUrlPrefix: "getStoreUrlPrefix",

      isStandardDeliveryInCart: "getPreprendCartStandardDeliveryInCart"

    }),
  },

  watch: {
    currentSelectedDelivery (newValue) {
      let currenShippingMethod = this.productShippingList[this.defaultSelectedShippingMethod]
      
      if(this.isZeborne == true) {
        if(newValue == 'delivery_only') {
          this.setPreprendCartIsRenting(false);
        } else {
          this.tva = true;
        }

        this.defaultSelectedShippingMethod = this.currentSelectedDelivery;
        let taxReducible = currenShippingMethod.is_tax_reducible;
        this.setProductSelectedShippingMethod(this.defaultSelectedShippingMethod, taxReducible);
      } else {
        this.tva = true;
      }

      
      this.setAppProductShippingMethodSpecialPrice(
        this.setProductShippingMethodsPrice(
          currenShippingMethod.is_tax_reducible, 
          currenShippingMethod.prices.final_price
          )
      )

      this.$emit("shipping-method-selected", this.defaultSelectedShippingMethod);
    },
  },

  methods: {
    openModalCalendar () {
      this.showModalCalendar = true;
      this.onModify = false;
      this.defaultSelectedShippingMethodId = this.productShippingList[
        this.defaultSelectedShippingMethod
      ].id;
    },
    reOpenModalCalendar () {
      this.showModalCalendar = true;
      this.onModify = true;
    },
    closeModalCalendar () {
      this.showModalCalendar = false;
    },
    openModalInfo (content) {
      this.modalContentInfo = content;
      this.showModalInfo = true;
    },
    closeModalInfo () {
      this.showModalInfo = false;
    },

    eventClickSelectedShippingMethod (event) {
      this.setProductSelectedShippingMethod(event.target.getAttribute("product-shipping-name"), event.target.getAttribute("is-tax-reducible"));
    },

    setProductSelectedShippingMethod (productShippingName, isTaxReducible) {
      this.setAppProductBillInfo(productShippingName);
      if( this.isZeborne == false ){
        this.setAppProductShippingIsTaxReducible(
            JSON.parse(isTaxReducible)
        );
      }

      this.setPreprendCartRelatedProducts();
      
      this.setPreprendCartCurrentSelectedDelivery(productShippingName);
      this.setCurrentDeliveryId(this.productShippingList[this.defaultSelectedShippingMethod].id);
      this.setPreprendCartInterventionProduct(this.productShippingList[productShippingName].id);
      if(productShippingName == 'delivery_only') {
        this.setAppProductRateTaxDeliveryClassic(this.tvaProfils.high_rate);
      }
      else {
        this.setAppProductRateTaxDeliveryClassic(this.tvaProfils.low_rate);
      }
      EventBus.$emit("update-price-cart");
    },

    scrollTo (event) {
      EventBus.$emit("action-scroll", event);
    },

    setCountDownExpired() {
      this.CountDownExpired = true;
    },

    setCountDownStarted() {
      this.CountDownExpired = false;
    },

    setProductShippingMethodsPrice(isTaxReducible, priceOptions) {
      let specialPrice;

      if(!isTaxReducible) {
        specialPrice = priceOptions[this.originalTva]
      } else {
        specialPrice = this.currentTva === 0 ? priceOptions[this.reducedTaxRate] : priceOptions[this.currentTva];
      }

      return specialPrice;
    },

    ...mapActions([
      "setAppProductBillInfo",
      "setAppProductShippingIsTaxReducible",
      "setPreprendCartRelatedProducts",
      "setPreprendCartCurrentSelectedDelivery",
      "setCurrentCartDeliveryAbsoluteType",
      "setCurrentDeliveryId",
      "setAppProductParticularTva",
      "setAppProductOriginalTva",
      "setPreprendCartInterventionProduct",
      "setPreprendCartIsRenting",
      "setPreprendCartIsFinancing",
      "setAppProductRateTaxDeliveryClassic",
      "setAppProductShippingMethodSpecialPrice"
    ]),

    toggleAppProductParticularTva () {
      this.tva ? this.setAppProductParticularTva(this.reducedTaxRate) : this.setAppProductParticularTva(this.tvaProfils.high_rate);
    },
  },

  created () {
    //If current cart contains product with standard delivery or url contains ?from=googleshopping and standard delivery is available
    if(this.isRetailable == true) {
      this.defaultSelectedShippingMethod = this.currentSelectedDelivery;
      this.defaultIsTaxReducible = false;
      
      //add mcp_intervention_product delivery for zeborne
      if(this.isZeborne && this.defaultSelectedShippingMethod) {
        this.setPreprendCartInterventionProduct(this.productShippingList[this.defaultSelectedShippingMethod].id);
      } 
    }



    if (this.isZeborne === true && !this.isLead) {
      this.defaultIsTaxReducible = false;
      this.modalCalendarComponent = () => ({
        component: ModalCalendarZeborne()
      });
    }
    
    EventBus.$on("display-dates-messages", () => {
      this.showSubmitMessages = true;
      this.openModalCalendar();
    });
    EventBus.$on("hide-dates-messages", () => (this.showSubmitMessages = false));
    this.tva = true;
  },

  mounted () {
    let defaultShippingMethod = null;
    for (const [key, value] of Object.entries(this.productShippingList)) {
      if (value.current_intervention || !this.productShippingList.hasOwnProperty(this.defaultSelectedShippingMethod)) {
        defaultShippingMethod = key;
        break;
      }
    }

    if (defaultShippingMethod) {
      this.defaultSelectedShippingMethod = defaultShippingMethod;
    }

    this.setPreprendCartCurrentSelectedDelivery(this.defaultSelectedShippingMethod);
    this.setCurrentCartDeliveryAbsoluteType(this.defaultSelectedShippingMethod);
    this.setAppProductBillInfo(this.defaultSelectedShippingMethod);
    this.setAppProductShippingIsTaxReducible(this.defaultIsTaxReducible);
    this.setPreprendCartRelatedProducts();
  }
};
</script>
